export interface AuditEnriched
{
	id: number;
	commitDate: Date;
	author: string;
	label: string;
	childType: string;
	childId: number | string;
	propertyName: string;
	left: any;
	right: any;
}


